const regex = {
  URL: /^https?:\/\/.+\..+$/,
  validEmail: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/,
  stateFile: /(^|,)([^,]+\.tfstate)(?=,|$)/g,
};
export default regex